<template>
    <div>
       <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <li><router-link to="/index"><a href="">首頁</a></router-link></li>
                        <li>補充說明</li>
                    </ul>
                </div>
            </div>

            <!--服務條款開始-->

            <div class="bodyContent">
                <div class="container">
                    <section class="uploadArea p_mgin20">
                        <div class="innerHeader">
                            <h1>補充說明</h1>
                        </div>
                        
                        <h2>支援的付款方式</h2>
                        <div class="group_pList">
                            <p>
                                您可以透過本平台支援的付款方式購買「點數」，並且取得收聽數位內容的權利。目前您可選擇使用 Google Play 「應用程式內購」 或 Apple 「App 內購買」（以下簡稱App 內購買）來購買「點數」：
                            </p>
                            <ol>
                                <li>
                                    當您在 iPhone 或 iPad 開啟「一刻鯨選」 App，進行「App 內購買」，您必須認證 Apple ID 與密碼，才能完成購買流程。 更多說明請參考<a href="https://support.apple.com/zh-tw/HT202023" target="_blank">Apple 官網</a>。
                                </li>
                                <li>
                                    如果您要在 Android 手機或平板電腦的「一刻鯨選」 App，進行「應用程式內購」，您需要輸入密碼或通過驗證後，方可進行應用程式內購買。更多說明請參考<a href="https://support.google.com/googleplay/answer/1061913?hl=zh-Hant" target="_blank">Google Play 官網</a>。
                                </li>
                            </ol>
                            <p>
                                如果您同意 Google Play 或 Apple 的 App 內購買，即代表您個人同意使用該項服務進行消費，並遵守您個人與該服務商間消費機制設定與協議，本公司不涉及您雙方之間的付款關係及與其有關的權利義務。
                            </p>
                        </div>

                        <h2>退費說明</h2>
                        <div class="group_pList">
                            <p>
                                如果您透過 Google Play 或 Apple 的 App 內購買點數，您可依循該服務商的退款流程進行申請：
                            </p>
                            <ol>
                                <li>
                                    Apple 「App 內購買」點數：若您想申請退款，請與 Apple 官方支援小組聯繫，您可透過<a href="https://idmsa.apple.com/IDMSWebAuth/signin?appIdKey=6f59402f11d3e2234be5b88bf1c96e1e453a875aec205272add55157582a9f61&path=%2F%3Fs%3D4&language=TW-ZH" target="_blank">這裡</a>向 Apple 申請退款。是否能順利退款，決定權在於 Apple 方，他們會由人工審核，建議詳述原因讓 Apple 人員明白。<br>
                                    注意：申請退款僅能在購買點數的 90 天內，超過 90 天後 Apple 將不予受理。
                                    
                                    ※ 更多說明請參考：<a href="https://support.apple.com/zh-tw/HT204084" target="_blank">https://support.apple.com/zh-tw/HT204084</a>
                                </li>
                                <li>
                                    Google Play 「應用程式內購」點數：若距離您購買點數的時間尚未超過 48 小時，可透過 Google Play 申請退款，您可以透過<a href="https://play.google.com/store/account?pli=1" target="_blank">這裡</a>向 Google Play 申請退款。
                                    
                                    ※ 更多說明請參考：<a href="https://support.google.com/googleplay/answer/7205930" target="_blank">https://support.google.com/googleplay/answer/7205930</a>
                                </li>
                            </ol>
                        </div>
                        
                        <h2>更換載具</h2>
                        <div class="group_pList">
                            <ol>
                                <li>
                                    當您用 Android 裝置使用本服務時，必須使用可被識別的身份驗證（udn會員、Facebook、Google 帳號、手機號碼）購買點數；在您更換裝置或裝置損壞、遺失時，可在新的裝置驗證身份後，即可重新取回您在本平台購買的付費服務權利。
                                </li>
                                <li>
                                    當您用 iOS 裝置使用本服務時，若您使用可被識別的身份驗證（udn會員、Facebook、Google 帳號、手機號碼）購買點數，在您更換裝置或裝置損壞、遺失時，可在新的裝置驗證身份後，即可重新取回您在本平台購買的付費服務權利。若您不是透過上述驗證方式購買，則將無法取回，建議您使用付費服務時，使用可被識別的身份驗證，以免喪失您的權利。
                                </li>
                            </ol>
                        </div>
                        <h2>載具存取之限制</h2>
                        <p>
                            本服務透過您提供載具之唯一裝置識別碼，限制每位用戶最多可於三個載具（含手機、平板電腦等）同時使用「一刻鯨選」的服務。
                        </p>
                        <p>
                            備註：本公司得隨時自行決定，針對您可用來存取數位內容之載具數量進行限制或變更其數量
                        </p>
                    
                    </section>
                    
                    
                </div>
            </div>

            <!--服務條款結束-->


        </main>
        
        
    </div>    
</template>

<script>
export default {
        name: 'async',
    metaInfo () {
      return {
        
        title: '服務使用補充說明 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '服務使用補充說明 | 一刻鯨選'},
            {property: 'og:site_name', content: '服務使用補充說明 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！'},
        
        ]
      }
    },
  
 data() {
    return {
       classData: [],
    }
  },
 methods: {
       

        changePage(page){
        this.$router.push({ path: "/"+page});

        }

　　},
    mounted() {
        $( "body" ).removeClass('index');
      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Info.vue